import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

class CashRegisterService {
  addCashRegister(idUser) {
    return api.get(UtilsUrl.shopURL() + "/addCashRegister/" + idUser);
  }
  addShop(addShopModel) {
    return api.post(UtilsUrl.shopURL() + "/addShop", addShopModel);
  }
  getAllCashRegister(idUser) {
    return api.get(UtilsUrl.shopURL() + "/getAllCashRegister/" + idUser);
  }
  getAllCashRegisterInShop(idUser, inShop) {
    return api.get(
      UtilsUrl.shopURL() +
        "/getAllCashRegisterNotInShop/" +
        idUser +
        "/" +
        inShop
    );
  }
  getAllShop(idUser) {
    return api.get(UtilsUrl.shopURL() + "/getAllShop/" + idUser);
  }
  getAllWarehousesNotInShop(idUser) {
    return api.get(UtilsUrl.shopURL() + "/getAllWarehousesNotInShop/" + idUser);
  }
}
export default new CashRegisterService();
